module.exports = __webpack_public_path__ + "img/0Q3B8222_Black_MockedUp.37b350fb.jpg";